/**
 * Hinweis auf Änderungen, die noch nicht beim Server sind, und auf Konflikte.
 * Bei einem Konflikt entscheidet die Person: eigene Fassung speichern oder
 * verwerfen (dann gilt die Fassung des anderen Geräts).
 */
import { useState } from 'react';
import { processOutbox, resolveEntry, useOutbox } from '../state/outbox.ts';
import { texts } from '../texts/de.ts';

/** Leiste über dem Inhalt, solange etwas wartet. */
export function SyncBanner() {
  const entries = useOutbox();
  const [open, setOpen] = useState(false);
  if (entries.length === 0) {
    return null;
  }
  const conflicts = entries.filter((entry) => entry.status !== 'waiting').length;

  return (
    <div className="mx-auto max-w-5xl px-4 pt-3">
      <div
        role="status"
        className={`rounded-xl px-3 py-2 text-sm ${conflicts > 0 ? 'bg-accent-soft text-accent-strong' : 'bg-surface-sunken'}`}
      >
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          className="flex w-full items-center justify-between gap-2 text-left"
        >
          <span>
            {conflicts > 0
              ? texts.sync.conflicts.replace('{count}', String(conflicts))
              : texts.sync.waiting.replace('{count}', String(entries.length))}
          </span>
          <span aria-hidden="true">{open ? '▲' : '▼'}</span>
        </button>
        {open ? (
          <ul className="mt-2 space-y-2">
            {entries.map((entry) => (
              <li key={entry.id} className="rounded-lg bg-surface-raised p-2 text-content">
                <p className="font-medium">{entry.label}</p>
                <p className="text-xs text-content-muted">
                  {entry.status === 'waiting'
                    ? texts.sync.statusWaiting
                    : entry.status === 'conflict'
                      ? texts.sync.statusConflict
                      : `${texts.sync.statusFailed}: ${entry.message ?? ''}`}
                </p>
                {entry.status === 'waiting' ? null : (
                  <div className="mt-2 flex flex-wrap gap-2">
                    <button
                      type="button"
                      onClick={() => resolveEntry(entry.id, 'mine')}
                      className="rounded-lg bg-accent px-3 py-1 text-xs font-semibold text-on-accent"
                    >
                      {entry.status === 'conflict' ? texts.sync.keepMine : texts.sync.retry}
                    </button>
                    <button
                      type="button"
                      onClick={() => resolveEntry(entry.id, 'discard')}
                      className="rounded-lg border border-border-subtle px-3 py-1 text-xs"
                    >
                      {entry.status === 'conflict' ? texts.sync.keepTheirs : texts.sync.discard}
                    </button>
                  </div>
                )}
              </li>
            ))}
            {conflicts === entries.length ? null : (
              <li>
                <button type="button" onClick={() => void processOutbox()} className="text-xs underline">
                  {texts.sync.tryNow}
                </button>
              </li>
            )}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
